import React, { useEffect, useRef, useMemo, useState } from 'react';
import { Toast } from 'primereact/toast';
import Cookies from 'universal-cookie/es6';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import apis from '../../api';
import authenticationService from '../../services/authentication.service';
import { Button } from 'primereact/button';
import useNetworkStatus from '../../helpers/useNetworkStatus';

function RenewSession({ time }) {
  const toast = useRef(null);
  const cookies = new Cookies();
  const [token, setToken] = useState('');
  let headers = {
    authorization: localStorage.getItem('token'),
  };
  const audioElement = useMemo(() => new Audio(process.env.REACT_APP_NOTIFICATION), []);
  const { isOnline } = useNetworkStatus();

  const timeoutRef = useRef(null);

  useEffect(() => {
    console.log("Se renueva la sesión");
    renoveSesion();
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [token, isOnline]);

  function renoveSesion() {
    if (cookies.get('token')) {
      headers = {
        authorization: localStorage.getItem('token'),
      };
      let expired = (parseInt(localStorage.getItem('expired')) + (time - 120) * 1000) - Date.now();
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(sayHi, expired);
    }
  }

  const accept = async () => {
    try {
      if (isOnline) {
        if (cookies.get('token')) {
          const res = await apis.getToken(headers);
          cookies.set('token', res.data, { expires: new Date(Date.now() + (time + 1) * 1000) });
          const minutes = time / 60;
          console.log(time, minutes);
          localStorage.setItem('expired', Date.now());
          localStorage.setItem('token', res.data);
          setToken(res.data);
          toast.current.show({ severity: 'info', summary: 'Confirmado', detail: `Tu sesión se extendió ${minutes} minutos`, life: 5000 });
        } else {
          if(window.location.pathname !== '/Kiosko'){
            window.location.href = "Login";
          }
          toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Sesión expirada', sticky: true });
        }
      }
    } catch (err) {
      cookies.remove('token');
      if (isOnline) {
        if(window.location.pathname !== '/Kiosko'){
          window.location.href = "Login";
        }
      }
    }
  };

  const reject = () => {
    authenticationService.signOut();
    setToken('');
    toast.current.show({ severity: 'info', summary: 'Rechazado', detail: 'Fin de la sesión', life: 5000 });
  };

  function sayHi() {
    if (isOnline) {
      audioElement.play();
      if (localStorage.getItem('kiosco')) {
        accept();
      } else {
        confirmDialog({
          header: 'En 2 minutos se termina la sesión',
          message: '¿Desea extender la sesión?',
          icon: 'pi pi-info-circle',
          accept,
          reject,
        });
      }
    } else {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'No hay conexión a internet.', life: 5000 });
    }
  }

  const closeButton = () => {
    return (
      <Button icon="pi pi-times" rounded text severity="secondary" aria-label="Cancel" onClick={() => reject()} />
    );
  };

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <ConfirmDialog closeIcon={closeButton} />
    </>
  );
}

export default RenewSession